module.exports = __webpack_public_path__ + "img/hospital7.28654e70.png";